import { NavigationTab } from 'shared/model';

import { AddUserButtonLink } from './buttons';

export const TABS: Array<NavigationTab> = [
  {
    key: 'roles',
    path: '',
    label: 'Управление пользователями',
    buttons: [
      {
        element: <AddUserButtonLink />,
        controller: 'Identity',
        right: 'Write',
      },
    ],
  },
];
